/** @file blendLocals: the outgoing clip's locals mixed into the incoming clip's by the outgoing share. */
import { quatSlerp } from '@zilo/pose3d-math/quat/quatSlerp';
import type { LocalPose } from '@zilo/pose3d-pose/sample/localTypes';

/**
 * Decision 10: `rot = slerp(to, from, weight)`, position and scale lerped likewise, discrete fields from `to`;
 * `weight` is the share of `from` (1 = exactly `from`'s continuous values). `out` may be `to`.
 */
export function blendLocals(from: LocalPose, to: LocalPose, weight: number, out: LocalPose): LocalPose {
  out.forEach((o, i) => {
    const a = to[i];
    const b = from[i];
    if (a === undefined || b === undefined) return;
    const r = weight >= 1 ? b.rot : weight <= 0 ? a.rot : quatSlerp(a.rot, b.rot, weight);
    const mix = (x: number, y: number) => (weight >= 1 ? y : weight <= 0 ? x : x + (y - x) * weight);
    o.pos[0] = mix(a.pos[0], b.pos[0]);
    o.pos[1] = mix(a.pos[1], b.pos[1]);
    o.pos[2] = mix(a.pos[2], b.pos[2]);
    o.scale = mix(a.scale, b.scale);
    o.rot[0] = r[0]; o.rot[1] = r[1]; o.rot[2] = r[2]; o.rot[3] = r[3];
    o.parent = a.parent; o.hidden = a.hidden; o.rotToggle = a.rotToggle; o.frameKey = a.frameKey;
  });
  return out;
}
